import { Box, Flex, Heading, Link, Text, VStack } from "@chakra-ui/react";
import { ReactNode } from "react";
import Section from "./primary/Section";
import GoogleIcon from "./primary/Icon";

type ContactItemProps = {
  icon: ReactNode;
  label: string;
  href: string;
  text: string;
};

const ContactItem = ({ icon, label, href, text }: ContactItemProps) => {
  return (
    <Flex
      alignItems="center"
      gap={4}
      flex="0 1 auto"
      minW="fit-content"
      maxW="100%"
    >
      <Box
        color="preview.primary"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        minW="32px"
      >
        {icon}
      </Box>
      <Box
        alignSelf="stretch"
        w="1px"
        bg="rgba(79, 111, 52, 0.18)"
        flexShrink={0}
      />
      <VStack alignItems="start" spacing={0} pl={1} minW={0} maxW="100%">
        <Text
          fontSize="sm"
          fontWeight={700}
          letterSpacing="0.12em"
          textTransform="uppercase"
          color="preview.primary"
        >
          {label}
        </Text>
        <Link
          href={href}
          color="cle.muted"
          fontSize={{ base: "md", md: "sm" }}
          lineHeight={1.5}
          wordBreak="break-word"
          isExternal={href.startsWith("http")}
        >
          {text}
        </Link>
      </VStack>
    </Flex>
  );
};

const Info = () => {
  return (
    <Section id="contact-expand" variant="cream" containerMaxW="110rem">
      <VStack
        maxW="full"
        mx="auto"
        spacing={4}
        align="stretch"
        py={{ base: 12, md: 16 }}
        color="cle.charcoal"
      >
        <VStack spacing={1} textAlign="center" maxW="3xl" mx="auto">
          <Heading as="h2" size="lg" color="preview.neutral">
            Contact Porooshat Sabeti
          </Heading>
          <Text color="cle.muted">Initiator of CLE</Text>
        </VStack>

        <Flex
          direction={{ base: "column", lg: "row" }}
          wrap="wrap"
          justify={{ base: "flex-start", lg: "center" }}
          align={{ base: "flex-start", lg: "center" }}
          gap={{ base: 8, md: 24 }}
          mx={{ base: 0, lg: "auto" }}
          w="full"
          maxW="9xl"
          pt={{ base: 2, md: 3 }}
        >
          <ContactItem
            label="Email"
            href="mailto:porooshat.sabeti@universityofgalway.ie"
            text="porooshat.sabeti@universityofgalway.ie"
            icon={<GoogleIcon name="mail" fontSize={28} color="currentColor" />}
          />
          <ContactItem
            label="Phone"
            href="tel:+353858405397"
            text="+353858405397"
            icon={<GoogleIcon name="smartphone" fontSize={28} color="currentColor" />}
          />
          <ContactItem
            label="LinkedIn"
            href="https://www.linkedin.com/in/porooshat-sabeti/"
            text="https://www.linkedin.com/in/porooshat-sabeti/"
            icon={<GoogleIcon name="link" fontSize={28} color="currentColor" />}
          />
        </Flex>
      </VStack>
    </Section>
  );
};

export default Info;
